import React from 'react';
import { Section } from './Section';
import { MessageCircle, Search, Map } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function StrategicEvaluation() {
  const steps = [{
    icon: <MessageCircle className="w-5 h-5 md:w-6 md:h-6" data-id="element-335" />,
    text: 'Atención inicial'
  }, {
    icon: <Search className="w-5 h-5 md:w-6 md:h-6" data-id="element-336" />,
    text: 'Revisión del caso'
  }, {
    icon: <Map className="w-5 h-5 md:w-6 md:h-6" data-id="element-337" />,
    text: 'Ruta recomendada'
  }];
  return <Section id="StrategicEvaluation" className="bg-white" data-id="element-338">
      <div className="max-w-4xl mx-auto" data-id="element-339">
        <div className="text-center mb-10" data-id="element-340">
          <span className="text-accent font-bold tracking-wider text-sm uppercase mb-3 block" data-id="element-341">
            Cómo comenzamos
          </span>

          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 mb-6" data-id="element-342">
            Antes de recomendarte una tienda online, revisamos tu caso
          </h2>

          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-343">
            Al solicitar la evaluación estratégica, un asesor de Bitzen revisará
            inicialmente tu situación por WhatsApp para entender cómo vende hoy
            tu negocio, en qué etapa está tu canal online y si BitzenEscala™
            tiene sentido para tu pyme.
          </p>
        </div>

        {/* Compact Steps Flow */}
        <div className="relative mb-10" data-id="element-344">
          <div className="hidden md:block absolute top-7 left-[16%] right-[16%] h-0.5 bg-slate-100 z-0" data-id="element-345"></div>

          <div className="grid grid-cols-3 gap-3 md:gap-6 relative z-10" data-id="element-346">
            {steps.map((step, i) => <div key={i} className="flex flex-col items-center justify-start text-center" data-id="element-347">
                <div className="bg-white border-2 border-accent text-accent w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center mb-3 shadow-sm" data-id="element-348">
                  {step.icon}
                </div>

                <span className="font-semibold text-navy-900 text-xs md:text-sm leading-tight px-1" data-id="element-349">
                  {step.text}
                </span>
              </div>)}
          </div>
        </div>

        {/* Big CTA Card */}
        <div className="bg-slate-50 rounded-3xl p-6 md:p-10 border border-slate-200 text-center shadow-sm" data-id="element-350">
          <CTAButton variant="primary" className="mb-4 w-full sm:w-auto" action="whatsapp" pixelEvent={{
          event: 'AddToCart',
          content_name: 'CTA Evaluación Estratégica - WhatsApp',
          content_category: 'BitzenEscala High Ticket',
          value: 1000000,
          currency: 'CLP'
        }} data-id="element-351">
            Solicitar evaluación estratégica
          </CTAButton>

          <p className="text-sm text-slate-500 font-medium" data-id="element-352">
            Atención inicial por WhatsApp para revisar tu caso y orientarte con
            claridad.
          </p>
        </div>
      </div>
    </Section>;
}